import type { WPFooterColumn } from "../../models/WPFooterSection";
import { configRefs } from "../constants/config";
import { DAYS_TO_MS, HOURS_TO_MS } from "../constants/time";
import { createCache } from "../createCache";

import type { ApiClientOptions } from "./typings/ApiClientOptions";
import type { ApiRequestInterceptor } from "./typings/ApiRequestInterceptor";
import { fetchRequest } from "./utils/fetchRequest";

export function makeFetchFooter(
  requestInterceptor: ApiRequestInterceptor,
  options: ApiClientOptions,
) {
  const cache = createCache<WPFooterColumn[]>({
    timeToLiveMs: 1 * HOURS_TO_MS,
    timeToEvictMs: 1 * DAYS_TO_MS,
    ...options,
  });

  return () =>
    cache("footer", async () => {
      const response = await fetchRequest<{
        sections: WPFooterColumn[];
      }>(
        requestInterceptor(
          `${await configRefs.apis.webproever.get()}/konfiguration/sidefod/`,
        ),
      );

      return response.sections;
    });
}
